import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './PersonalizablePrimaryHeader.css';
import React from 'react';
import { canUseDOM, get, getColorByTheme, getPageThemeColors } from '../../utils';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { headerImageStyle } from '../57_HeaderArticle1/HeaderArticle1';
import { fullWidthStyles } from '../57_HeaderFullWidth/headerFullWidth';
import HeaderMedia from '../57_HeaderMedia/HeaderMedia';
import RouterLink from '../atoms/RouterLink';
import { tealiumClickFunc } from '../../utils/tealium';
var videoWhiteOverlayTime = 750;
var videoFadeTime = 400;
var PersonalizablePrimaryHeader = function PersonalizablePrimaryHeader(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = useSitecoreContext();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var title = get(fields, 'data.item.title.jss');
  var introText = get(fields, 'data.item.introText.jss');
  var fallbackImage = get(fields, 'data.item.fallbackImage');
  var personalizableVideo = get(fields, 'data.item.personalizableVideo');
  var publicationDate = get(personalizableVideo, 'jss.value.createdDate');
  var personalizableImage = get(fields, 'data.item.personalizableImage');
  var isEmptyPersonalizableImage = get(fields, 'data.item.personalizableImage.jss.value.src');
  var videoAnalytics = get(fields, 'data.item.videoAnalytics');
  var contextName = get(fields, 'data.context.name');
  var ctaLink = get(fields, 'data.item.ctaLink.jss.value.href');
  var ctaLabel = get(fields, 'data.item.ctaLabel.jss.value');
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var variables = BackgroundColorHex ? {
    "--m57-personalizable-primary-header-background-color": BackgroundColorHex,
    "--m57-personalizable-primary-header-background-active-color": ActiveColorHex,
    "--m57-personalizable-primary-header-color": ColorHex
  } : {
    "--m57-personalizable-primary-header-background-color": selectedPrimaryColor,
    "--m57-personalizable-primary-header-background-active-color": primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    "--m57-personalizable-primary-header-color": getColorByTheme(selectedPrimaryColor)
  };
  if (!fields) {
    console.info('PersonalizablePrimaryHeader component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [PersonalizablePrimaryHeader component is empty: please provide data source]");
    }
    return null;
  }

  //composing media data for header media component from the supplied fields and render this media
  //if component is personalized, it can't contain nested placeholders, so we render media directly from the datasource item instead of rendering media placeholder
  var renderMedia = function renderMedia() {
    var coverImage = isEmptyPersonalizableImage ? personalizableImage : fallbackImage;
    if (!coverImage && pageEditing) {
      return /*#__PURE__*/React.createElement("div", null, "[Header Media: please provide data source or item should have headerImage field.]");
    }
    var mediaItem = {
      image: coverImage,
      video: personalizableVideo,
      name: title ? title.value : '',
      publicationDate: {
        jss: {
          value: publicationDate ? new Date(publicationDate.split('-')).toISOString() : ''
        }
      },
      description: introText ? introText.value : ''
    };
    var mediaFields = {
      data: {
        item: mediaItem,
        videoAnalytics: videoAnalytics
      }
    };
    return /*#__PURE__*/React.createElement(HeaderMedia, {
      fields: mediaFields,
      params: _objectSpread({}, params)
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "header header-generic--primary",
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-media"
  }, renderMedia()), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12 header-content__container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-content theme-contrast"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-animate__content-bg theme-contrast"
  }), /*#__PURE__*/React.createElement("div", {
    className: "c-content__main header-animation__content"
  }, title && /*#__PURE__*/React.createElement(Text, {
    className: "c-content__title",
    tag: "h1",
    field: title
  }), introText && /*#__PURE__*/React.createElement(Text, {
    className: "c-content__text",
    tag: "p",
    field: introText
  }), ctaLabel && ctaLink && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RouterLink, {
    href: ctaLink,
    className: "btn btn-secondary c-content__btn desktop__link ",
    onClick: function onClick() {
      tealiumClickFunc(params, contextName);
    },
    title: ctaLabel
  }, ctaLabel), /*#__PURE__*/React.createElement(RouterLink, {
    href: ctaLink,
    className: "btn btn-primary mob__link",
    onClick: function onClick() {
      tealiumClickFunc(params, contextName);
    },
    title: ctaLabel
  }, ctaLabel))))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  })))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "header-animation ".concat(commonStyles, " ").concat(fullWidthStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(headerImageStyle),
    removePaddingHeader: true,
    componentTabIndex: "disabled"
  }, children);
};
export var commonStyles = "covwi60";
export var ltrStyles = "loifk3h";
export var rtlStyles = "rnjpy1i";
export default PersonalizablePrimaryHeader;